<template>
  <table class="product-rows product-rows--invoice-history">
    <thead>
      <tr>
        <th class="product-row__head-invoice-number">
          <div v-epi-edit="'HeaderInvoiceNumber'" class="product-row__head-inset">
            <span>
              {{ t('headerInvoiceNumber') }}
            </span>
          </div>
        </th>

        <th class="product-row__head-invoice-type">
          <div v-epi-edit="'HeaderInvoiceType'" class="product-row__head-inset">
            <span>
              {{ t('headerInvoiceType') }}
            </span>
          </div>
        </th>

        <th class="product-row__head-invoice-type">
          <div v-epi-edit="'HeaderInvoiceType'" class="product-row__head-inset">
            <span>
              {{ t('headerOrderNumber') }}
            </span>
          </div>
        </th>

        <th class="product-row__head-invoice-date">
          <div v-epi-edit="'HeaderInvoiceDate'" class="product-row__head-inset">
            {{ t('headerInvoiceDate') }}
          </div>
        </th>

        <th class="product-row__head-invoice-date">
          <div v-epi-edit="'HeaderInvoiceDate'" class="product-row__head-inset">
            {{ t('headerDueDate') }}
          </div>
        </th>

        <th class="product-row__head-status">
          <div v-epi-edit="'HeaderInvoiceStatus'" class="product-row__head-inset">
            {{ t('headerInvoiceStatus') }}
          </div>
        </th>

        <th class="product-row__head-total-sum">
          <div v-epi-edit="'HeaderInvoicePrice'" class="product-row__head-inset product-row__head-inset--align-right">
            <span>{{ t('headerInvoiceAmount') }}<!--Totalt (exkl. moms)--></span>
          </div>
        </th>

        <th class="product-row__head-invoice-alternatives">
          <div v-epi-edit="'HeaderInvoiceAlternatives'" class="product-row__head-inset product-row__head-inset--align-right">
            <span>
              {{ t('headerInvoiceReturn') }}
            </span>
          </div>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(invoice, row) in invoices" :key="`table-row-${row}`" :class="{ 'highlighted-row': shouldHighlightRow(invoice) }">
        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('headerInvoiceNumber') }}
          </div>

          <div class="product-row__body-inset invoice_ocr">
            <button :aria-label="`Open invoice with OCR ${invoice.ocr}`" @click="handleSelectInvoice(invoice)">
              {{ invoice.ocr }}
            </button>
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('headerInvoiceType') }}
          </div>

          <div class="product-row__body-inset">
            {{ invoice.documentType }}
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('headerOrderNumber') }}
          </div>

          <div class="product-row__body-inset">
            {{ invoice.orderNumber }}
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('headerInvoiceDate') }}
          </div>

          <div class="product-row__body-inset">
            {{ invoice.displayInvoiceDate }}
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('headerDueDate') }}
          </div>

          <div class="product-row__body-inset">
            {{ invoice.displayDueDate }}
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('headerInvoiceStatus') }}
          </div>

          <div class="product-row__body-inset">
            {{ invoice.displayStatus }}
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('headerInvoicePrice') }}
          </div>

          <div class="product-row__body-inset product-row__body-inset--align-right product-row__body-inset--price">
            {{ formatPrice(invoice.invoiceAmount) }}
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header product-row__body-inset--align-right">
            {{ t('headerInvoiceReturn') }}
          </div>

          <div class="product-row__body-inset product-row__body-inset--align-right">
            <!--FIX-->
            <a
              v-tooltip.top="t('downloadInvoiceTooltip')"
              :href="`/mvcapi/se/sv/invoice/invoice-document/${invoice.invoiceNumber}`"
              class="product-row__order-return"
              @click="downloadFile(invoice, $event.target)">
              <oie-use-svg svg="download-invoice"></oie-use-svg><span v-if="mq('small')"></span>
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import myPages from '@/mixins/my-pages'
import { mapGetters, mapActions } from 'vuex'
import httpService from '@/core/http-service'

export default {
  mixins: [myPages],
  props: {
    invoices: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    customer: {
      orderReturnIssues: []
    }

  }),
  computed: {
    ...mapGetters('myInvoiceHistory', ['myMachines', 'myMachinesFilter', 'filteredMachineOwners', 'filteredMachines'])
  },
  mounted() {
    httpService
      .get(`order-return/customer`, {})
      .then(response => {
        this.customer = response.data
      })
  },
  methods: {
    ...mapActions('myInvoiceHistory', ['setCurrentInvoice']),
    handleSelectInvoice(invoice) {
      this.setCurrentInvoice(invoice)
      this.goToSubPage(this.navigationOptions.oieInvoiceHistoryDetails)
    },
    shouldHighlightRow(invoice) {
      return invoice.status === 'Overdue'
    },
    downloadFile(item, button) {
      button.classList.add('invoice-download-is-loading')

      setTimeout(() => {
        button.classList.remove('invoice-download-is-loading')
      }, 7000)
    }
  }
}
</script>

<style lang="scss">
  .product-rows--invoice-history .product-row__body-inset {
    min-height: initial;
  }

  .product-row__invoice-return {
    text-decoration: none;
  }

  .product-row__invoice-return:hover {
    text-decoration: underline;
  }

  .product-row__invoice-return > span {
    font-family: Open Sans,sans-serif;
    font-weight: 400;
    font-size: 1rem;
    color: #0088c8;
    padding-left: 4px;
    padding-bottom: 4px;
  }

  .issue-number {
    color: #e48123;
  }

  .highlighted-row {
    color: red;
  }

  .invoice_ocr {
    flex: 1;
  }

  .invoice_ocr > :first-child {
    @include reset-button;
    font-family: Open Sans,sans-serif;
    font-weight: 600;
    font-size: 1rem;
    color: #0088c8;
    margin: 0;
    padding: 0;
    text-align: left;
    z-index: 1;
    text-decoration: underline;
  }

  .invoice_ocr > :first-child::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .invoice_ocr > :first-child:hover {

  }

  .invoice_ocr > :nth-child(2) {
    @include caption;
    color: color(gray-2);
  }

  .invoice-download-is-loading {
    position: relative;
    pointer-events: none;

    &:hover {
      cursor: default;
    }

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: .825rem;
      transform: translate(-50%, -50%);
      width: 1.375rem;
      height: 1.375rem;
      background-color: transparent;
      border-radius: 50%;
      border: .2rem solid color(background-white);
      border-top-color: color(background-blue);
      animation: 800ms spin linear infinite;
      z-index: 2;
    }
  }

  .invoice-download-is-loading > svg {
    visibility: hidden;
  }
</style>
